import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import food from "../../assets/images/sidebar-icons/food.svg";
import foodCategory from "../../assets/images/sidebar-icons/food-category.svg";
import Administrativesettings from "assets/images/sidebar-icons/Administrativesettings.svg";

import ingredients from "../../assets/images/sidebar-icons/ingredients.svg";
import managment from "../../assets/images/sidebar-icons/managment.svg";
import socialMedia from "../../assets/images/sidebar-icons/social-media-campaign.svg";
import guide from "../../assets/images/sidebar-icons/guide.svg";
import branch from "../../assets/images/sidebar-icons/branch.svg";
import gallery from "../../assets/images/sidebar-icons/gallery.svg"
import aboutUs from "../../assets/images/sidebar-icons/about-us.svg"

const Sidebar = () => {
  const navigate = useNavigate();

  const hamburgerMenuIcon = useRef();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const closeHamburgerMnu = (e) => {
    e.preventDefault();
    hamburgerMenuIcon.current.checked = false;
    setShowHamburgerMenu(false);
  };
  useEffect(() => {
    // console.log(localStorage.getItem("token"));
    if (localStorage.getItem("token") === null) {
      navigate("/login");
    }
  }, []);
  return (
    <>
      <div className="hamburger-menu-container">
        <input
          className="checkbox"
          type="checkbox"
          ref={hamburgerMenuIcon}
          onChange={() => setShowHamburgerMenu(!showHamburgerMenu)}
        />
        <div className="hamburger-lines">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </div>
      </div>

      <div className={`sidebar ${showHamburgerMenu ? "show-sidebar" : ""}`}>
        <div className="list-items-container">
          <ul className="list-items">
            <li className="list-item">
              <img src={managment} alt="" srcSet="" />
              <span className="list-item-text">مدیریت </span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/foods"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={food} alt="icon" />
                <span className="list-item-text">غذاها</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/categories"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={foodCategory} alt="icon" />
                <span className="list-item-text">دسته بندی ها</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/contents"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={ingredients} alt="icon" />
                <span className="list-item-text">محتویات</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/locations"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={branch} alt="icon" />
                <span className="list-item-text">شعبه ‌ها</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/image-galleries"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={gallery} alt="icon" />
                <span className="list-item-text">گالری تصاویر</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/social-media"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={socialMedia} alt="icon" />
                <span className="list-item-text">شبکه‌های اجتماعی</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={aboutUs} alt="icon" />
                <span className="list-item-text">درباره ما</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/learn-how-to-use-panel"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={guide} alt="icon" />
                <span className="list-item-text">راهنما</span>
              </NavLink>
            </li>
          </ul>
          <ul className="list-items">
            <li className="list-item">
              <img src={managment} alt="" srcSet="" />
              <span className="list-item-text">خروج </span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
                localStorage.clear();
                window.location.href = "/login";
              }}
            >
              <NavLink
                to="/"
                className="link"
              >
                <img className="list-item-icon" src={Administrativesettings} alt="icon" />
                <span className="list-item-text">خروج</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
